<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
				<FormItem label="设备信息" prop="macDetailsId" class="sj">
					<Select v-model="formValidate.macDetailsId" placeholder="请选择类型设备信息">
						<Option v-for="(item,i) in macs" :key="i"  :value="item.id" >{{item.name}}</Option>
						
					</Select>
				</FormItem>
				<FormItem label="设备单价" prop="unitPrice" class="sj">
					<Input v-model="formValidate.unitPrice" placeholder="请输入设备单价"></Input>
				</FormItem>
				<FormItem label="设备数量" prop="number" class="sj">
					<Input v-model="formValidate.number" placeholder="请输入数量"></Input>
				</FormItem>
				
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					unitPrice: '',
					number: '',
					macDetailsId: '',
					finReportContractId:''
				},
				macs:[],
				ruleValidate: {
					macDetailsId: [{
						required: true,
						message: '请选择设备！！！',
						trigger: 'blur'
					}],
					unitPrice: [{
						required: true,
						message: '请输入设备单价！！！',
						trigger: 'blur'
					}],
					number: [{
						required: true,
						message: '请输入设备数量！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			ret() {//返回上一页
				this.$router.go(-1)
			},
			 handleSubmit (name) {
				 let _this=this
                this.$refs[name].validate((valid) => {
                    if (valid) {
					    let aa={
							unitPrice: _this.formValidate.unitPrice*100,
							number: _this.formValidate.number,
							macDetailsId: _this.formValidate.macDetailsId,
							finReportContractId:_this.formValidate.finReportContractId
						}
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/fin/report/contract/details/add',
						    data: aa,
							_this: _this,
							success: function(data) {
								_this.$Message.success('新增成功!');
								_this.$refs[name].resetFields();
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
                      
                    } else {
                        this.$Message.error('请完善信息后再进行提交!');
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            },
			queryMac(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/details/page/platform',
				    data:  {page:0,size:1000},
					_this: _this,
					success: function(data) {
						_this.macs=data.macDetails.content
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				 
			}
		},
		created(){
			let _this=this
			_this.formValidate.finReportContractId=_this.$route.query.orderId
			_this.queryMac()
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/macOrder/details/add.vue